/*!
 * jQuery Cookie Plugin v1.3.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */ (function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as anonymous module.
        define(['jquery'], factory);
    } else {
        // Browser globals.
        factory(jQuery);
    }
})(function ($) {
    var pluses = /\+/g;

    function raw(s) {
        return s;
    }

    function decoded(s) {
        return decodeURIComponent(s.replace(pluses, ' '));
    }

    function converted(s) {
        if (s.indexOf('"') === 0) {
            // This is a quoted cookie as according to RFC2068, unescape
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        }
        try {
            return config.json ? JSON.parse(s) : s;
        } catch (er) {}
    }

    var config = ($.cookie = function (key, value, options) {
        // write
        if (value !== undefined) {
            options = $.extend({}, config.defaults, options);

            if (typeof options.expires === 'number') {
                var days = options.expires,
                    t = (options.expires = new Date());
                t.setDate(t.getDate() + days);
            }

            value = config.json ? JSON.stringify(value) : String(value);

            return (document.cookie = [
                config.raw ? key : encodeURIComponent(key),
                '=',
                config.raw ? value : encodeURIComponent(value),
                options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                options.path ? '; path=' + options.path : '',
                options.domain ? '; domain=' + options.domain : '',
                options.secure ? '; secure' : '',
            ].join(''));
        }

        // read
        var decode = config.raw ? raw : decoded;
        var cookies = document.cookie.split('; ');
        var result = key ? undefined : {};
        for (var i = 0, l = cookies.length; i < l; i++) {
            var parts = cookies[i].split('=');
            var name = decode(parts.shift());
            var cookie = decode(parts.join('='));

            if (key && key === name) {
                result = converted(cookie);
                break;
            }

            if (!key) {
                result[name] = converted(cookie);
            }
        }

        return result;
    });

    config.defaults = {};

    $.removeCookie = function (key, options) {
        if ($.cookie(key) !== undefined) {
            // Must not alter options, thus extending a fresh object...
            $.cookie(
                key,
                '',
                $.extend({}, options, {
                    expires: -1,
                }),
            );
            return true;
        }
        return false;
    };
});

jQuery.fn.referrer = function () {
    return jQuery(document).prop('referrer').toString();
};

/* Promobox HP */
(function ($) {
    $.fn.promobox = function (repeat, sec) {
        var rand = Math.floor(Math.random() * 4) + 1;
        var timer = setInterval(function () {
            nextPromo();
        }, sec * 1000);
        var main = this;
        function nextPromo() {
            if (main.find('> div:visible').attr('id') != 'promo-4') {
                main.find('> div:visible').hide().next().show();
                main.find('.ui-state-active')
                    .removeClass('ui-state-active')
                    .next()
                    .addClass('ui-state-active');
            } else {
                main.find('> div:visible').hide();
                main.find('> div:first').show();
                main.find('.ui-state-active').removeClass('ui-state-active');
                main.find('li:first').addClass('ui-state-active');
            }
            if (!repeat)
                if (main.find('.ui-state-active').find('a').attr('rel') == rand)
                    clearInterval(timer);
        }
        this.find('> div').hide();
        this.find('#promo-' + rand).show();
        this.find('a[rel=' + rand + ']')
            .parent()
            .addClass('ui-state-active');
        this.find('div[id=smallPromo' + rand + ']')
            .parent()
            .addClass('ui-state-active');
        this.find('li').mouseenter(function () {
            clearInterval(timer);
            main.find('.ui-state-active').removeClass('ui-state-active');
            $(this).addClass('ui-state-active');
            main.find('> div').hide();
            main.find('#promo-' + $(this).find('a').attr('rel')).show();
        });
        return this;
    };
})(jQuery);

/* ENQUIRIES
-----------------------------------------------------------------------------*/

var msg_okVote = 'Děkujeme za Váš hlas. Váš hlas se projeví do několika minut.';
var err_cantVote = 'Litujeme, ale hlasovat můžete vždy jenom jednou denně.';

function enquiry_hp_vote(id, enq, mag, enq_hp_id) {
    // pokud existuje cookis s nazvem ID ankety a hodnotou "voted", tak vypišeme chybovou hlašku - a přesměrujeme
    okVote_url = eval('okVote_url_' + enq_hp_id);
    if ($.cookie(enq_hp_name) == 'voted') {
        if ($('#enquiry_' + enq + ' .enqMiddle .enqBar .voted').length == 1) {
            $('#enquiry_' + enq + ' .enqMiddle .enqBar .voted').text(err_cantVote);
        } else {
            $('#enquiry_' + enq + ' .enqMiddle .enqBar .voted').text(err_cantVote);
        }
        // upozorníme i alertem
        alert(err_cantVote);
        //... a pokud je link, tak přesměrujeme na novou stránku
        if (okVote_url != '') {
            window.location = okVote_url;
        }
    } else {
        $.ajax({
            type: 'GET',
            url: '/enquiries/' + id + '/vote/' + enq + '/' + mag,
            dataType: 'json',
            success: function (res) {
                if (res.ok == 'true') {
                    $.cookie(enq_hp_name, 'voted', 1);
                    $('#enquiry_' + enq + ' .enqMiddle .enqBar .voted').text(msg_okVote);
                    alert(msg_okVote);
                }
                // v každém případě přesměrujeme na link, pokud existuje...
                if (okVote_url != '') {
                    window.location = okVote_url;
                }
            },
        });
    }
}

/* stickyfloat
------------------------------------------------------------------------------*/
$.fn.stickyfloat = function (options, lockBottom) {
    var sticky = this;
    lockBottom = lockBottom || 0;
    if (typeof sticky.offset() != 'undefined' && sticky.offset() != null) {
        var objClass = sticky.attr('class');
        var topPos = sticky.offset().top - parseFloat(sticky.css('marginTop').replace(/auto/, 0));
        var childrenHeightFull = 0;
        sticky
            .parent()
            .children()
            .each(function () {
                childrenHeightFull =
                    parseFloat(childrenHeightFull) + parseFloat($(this).outerHeight());
            });
        var childrenHeight = childrenHeightFull - parseFloat(sticky.outerHeight());

        sticky.parent().css('height', sticky.closest('.container').height());
        $(window).scroll(function (evt) {
            var y = $(this).scrollTop();

            if (y > topPos) {
                if (
                    y <
                    topPos +
                        parseFloat(sticky.closest('.container').outerHeight()) -
                        childrenHeight -
                        sticky.outerHeight()
                ) {
                    sticky.addClass('fixed').removeAttr('style');
                } else {
                    sticky.removeClass('fixed').css({
                        position: 'absolute',
                        bottom: 0 + lockBottom,
                    });
                }
            } else {
                sticky.removeClass('fixed');
            }
        });
    }
};

/* stickyfloatMultiple - jedná se o stickyfloat např. na HP, kde se nachází více sticky bannerů
-------------------------------------------------------------------------------------------------*/
$.fn.stickyfloatMultiple = function (options, lockBottom) {
    var sticky = this;

    var settings = $.extend(
        {
            height: '1500px',
        },
        options,
    );

    var floatVideo = parseInt(window.cnc_floatVideo) || 0;

    var topPos =
        sticky.offset().top -
        parseFloat(sticky.css('marginTop').replace(/auto/, 0)) -
        20 -
        floatVideo;

    sticky.parent().css('height', settings.height);

    lockBottom = lockBottom || 0;
    if (typeof sticky.offset() != 'undefined' && sticky.offset() != null) {
        var objClass = sticky.attr('class');
        var childrenHeight = parseFloat(sticky.outerHeight());

        $(window).one('scroll', function (evt) {
            /* recount delayed boxes, coz for example twitter delay */
            topPos =
                sticky.offset().top -
                parseFloat(sticky.css('marginTop').replace(/auto/, 0)) -
                20 -
                floatVideo;
            /* counts and change necessary height of  sticky bottom adv. - nejdolnejsi dojezdova reklama v pravem sloupci*/
            recountStickyBottomHeight('first');
        });

        $(window).scroll(function (evt) {
            var y = $(this).scrollTop();

            if (sticky.offset().top < sticky.parent().offset().top) {
                // ošetření horní hranice posunu
                sticky.removeClass('fixed');
            } else if (y > topPos) {
                if (
                    y < topPos + parseFloat(sticky.parent().innerHeight()) &&
                    sticky.offset().top > sticky.parent().offset().top
                ) {
                    sticky.addClass('fixed').removeAttr('style').css('top', '10px');
                } else {
                    sticky.removeAttr('style');
                    sticky.removeClass('fixed').css({
                        position: 'absolute',
                        bottom: 0 + lockBottom,
                        top: 'unset',
                    });
                }

                floatVideo = parseInt(window.cnc_floatVideo) || 0;
                if (floatVideo > 0) {
                    sticky.css('top', floatVideo + 'px');
                }

                // ošetření spodní hranice posunu
                if (y + sticky.innerHeight() > topPos + parseFloat(sticky.parent().innerHeight())) {
                    sticky.removeAttr('style');
                    sticky.removeClass('fixed').css({
                        position: 'absolute',
                        bottom: 0 + lockBottom,
                        top: 'unset',
                    });
                }
            } else {
                sticky.removeClass('fixed');
            }
        });
    }
};

/* @stickyfloatRight **********************************************************/
/******************************************************************************/

$.fn.stickyfloatRight = function (stickyElementNextBottom) {
    if (!stickyElementNextBottom) {
        stickyElementNextBottom = '0';
    }

    $('.bottomStickyBlock').css({ position: 'absolute', bottom: '0' });

    $('#sticky-bottom-right-absolute').css({
        position: 'absolute',
        bottom: stickyElementNextBottom.toString() + 'px',
    });

    /* Variables **************************************************************/

    /* Selectors */
    var stickyElement = $(this);

    /* Values */
    var stickyElementPosition = stickyElement.css('position');
    var stickyElementTop = stickyElement.offset().top;
    var stickyElementTopOriginal = stickyElement.css('top');
    var stickyElementHeight = stickyElement.outerHeight(true);

    if (stickyElement.next().length) {
        var stickyElementNextTop = stickyElement.next().offset().top;
        var stickyElementNextTopRel = stickyElement.next().position().top;
    } else {
        var stickyElementParentHeight = stickyElement.parent().height();
        var stickyElementParentTop = stickyElement.offset().top;
        var bottomLine = parseInt(stickyElementParentHeight + stickyElementParentTop);
    }

    /* Process on window load */
    if (stickyElementTop <= $(window).scrollTop()) {
        /* Set stickyElement to fixed position */
        stickyElement.css({ position: 'fixed', top: '70px' });
    } else {
        stickyElement.css({
            position: stickyElementPosition,
            top: stickyElementTopOriginal,
        }); /* Set stickyElement to absolute position */
    }

    if (parseInt(stickyElementNextTop - stickyElementHeight) <= $(window).scrollTop()) {
        /* Set stickyElement to absolute position, when it reaches the next element */
        stickyElement.css({
            position: 'absolute',
            top: parseInt(stickyElementNextTopRel - stickyElementHeight),
        });
    }

    /* Process after window load, on window scroll */
    $(window).scroll(function () {
        var videoMargin = 0;
        try {
            videoMargin =
                typeof window.cnc_floatVideo == 'undefined' ? 70 : parseInt(window.cnc_floatVideo);
        } catch (e) {}

        if (stickyElementTop <= $(window).scrollTop()) {
            /* Set stickyElement to fixed position */
            //stickyElement.css({"position":"fixed", "top":"0"});
            stickyElement.css({ position: 'fixed', top: videoMargin + 'px' });
        } else {
            stickyElement.css({
                position: stickyElementPosition,
                top: stickyElementTopOriginal,
            }); /* Set stickyElement to absolute position */
        }

        if (stickyElement.next().length) {
            if (parseInt(stickyElementNextTop - stickyElementHeight) <= $(window).scrollTop()) {
                /* Set stickyElement to absolute position, when it reaches the next element */
                stickyElement.css({
                    position: 'absolute',
                    top: parseInt(
                        stickyElementNextTopRel - stickyElementHeight - stickyElementNextBottom,
                    ),
                });
            }
        } else {
            if (parseInt(bottomLine - stickyElementHeight) <= $(window).scrollTop()) {
                /* Set stickyElement to absolute position, when it reaches the next element */
                stickyElement.css({
                    position: 'absolute',
                    top: parseInt(stickyElementParentHeight - stickyElementHeight),
                });
            }
        }
    });
};

// Hlasovani napr. v modni policii
var artvoteonce = 'Hodnotit můžete pouze jednou.';
var artvotethanks = 'Děkujeme. Váš hlas se projeví do několika minut.';

var artvoted = Array;

function artVote(val, votefor) {
    var ii = new Image();
    if (!votefor) votefor = artvotebase;
    if (!artvoted[votefor]) {
        if (null !== votefor) {
            ii.src = votefor + val;
            alert(artvotethanks);
            artvoted[votefor] = 1;
        } else {
            alert(artvoteonce);
        }
    } else {
        alert(artvoteonce);
    }
}

/* FORUMS - diskuse pod clankem */
// zablokovani užiatele diskuse
function addReason(user, actpage, thread) {
    var reason = prompt('Udejte prosím důvod na ban:', '');
    if (reason) {
        var uri = '/threadwrite/' + thread;
        uri += '/' + actpage;
        uri += '/user_edit?user=' + user;
        uri += '&warn=ban&reason=';
        uri += reason;
        if (reason.length != 0) {
            location.href = uri;
        }
    }
}

function makeForm(idm) {
    if (formPos != idm) {
        var oldPos = document.getElementById('mess' + formPos);
        var newPos = document.getElementById('mess' + idm);

        formPos = idm;

        newPos.innerHTML = oldPos.innerHTML;
        newPos.style.display = 'block';
        oldPos.style.display = 'none';
        oldPos.innerHTML = '';
    }
}

var msgs = {
    title: 'Musíte mít vyplněn nadpis.',
    text: 'Musíte mít vyplněn text.',
    titleLen: 'Nadpis musí obsahovat alespoň 3 znaky.',
    textLen: 'Text musí obsahovat alespoň 5 znaku.',
    advtitle: 'Musíte mít vyplněno téma.',
    advtitleLen: 'Text musí obsahovat alespoň 3 znaky.',
    loginTitle: 'Musíte zadat přihlašovací údaje.',
    noChkMsg: 'Pro přihlášení do diskuse musíte souhlasit s pravidly diskuse.',
};

var formPos = 0;

$(document).ready(function () {
    if (window.location.href.indexOf('#') <= 0) {
        $('#subj').focus();
    }

    $('.diskCont textarea').each(function () {
        if ($(this).attr('id') != 'badwords') {
            $(this).html('');
        }
    });

    $('form[name=replyform]').submit(function (e) {
        if ($('#subj').val() == '') {
            e.preventDefault();
            alert(msgs.title);
        } else if ($('#subj').val().length < 3) {
            e.preventDefault();
            alert(msgs.titleLen);
        } else if ($('#frmCont').val() == '') {
            e.preventDefault();
            alert(msgs.text);
        } else if ($('#frmCont').val().length < 5) {
            e.preventDefault();
            alert(msgs.textLen);
        }
    });

    $('form[name=askform]').submit(function (e) {
        if ($('input[name=advtitle]').val() == '') {
            e.preventDefault();
            alert(msgs.advtitle);
        } else if ($('input[name=advtitle]').val().length < 3) {
            e.preventDefault();
            alert(msgs.advtitleLen);
        }
    });
});

function checkCheck(iid) {
    if (document.getElementById(iid).checked == false) {
        alert(msgs.noChkMsg);
        return false;
    } else {
        return true;
    }
}

function makeForm(idm) {
    if (formPos != idm) {
        if (idm != 0) {
            $('#mainReact').show();
        } else {
            $('#mainReact').hide();
        }
        var oldPos = document.getElementById('mess' + formPos);
        var newPos = document.getElementById('mess' + idm);

        document.getElementById('parId').value = idm;
        formPos = idm;

        newPos.innerHTML = oldPos.innerHTML;
        newPos.style.display = 'block';
        oldPos.style.display = 'none';
        oldPos.innerHTML = '';

        if (idm != 0) {
            document.getElementById('subj').value = 'Re: -----';
        } else {
            document.getElementById('subj').value = '-----';
        }
        document.getElementById('frmCont').focus();
    }
}

function makeFormSubj(idm, subj) {
    if (formPos != idm) {
        if (idm != 0) {
            $('#mainReact').show();
        } else {
            $('#mainReact').hide();
        }
        var oldPos = document.getElementById('mess' + formPos);
        var newPos = document.getElementById('mess' + idm);

        document.getElementById('parId').value = idm;
        formPos = idm;

        newPos.innerHTML = oldPos.innerHTML;
        newPos.style.display = 'block';
        oldPos.style.display = 'none';
        oldPos.innerHTML = '';

        if (idm != 0) {
            if (subj != '') {
                document.getElementById('subj').value = 'Re: ' + subj;
            } else {
                document.getElementById('subj').value = 'Re: -----';
            }
        } else {
            if (subj != '') {
                document.getElementById('subj').value = subj;
            } else {
                document.getElementById('subj').value = '-----';
            }
            document.getElementById('subj').value = '-----';
        }
        // document.getElementById('frmCont').focus();
    }
}

function loginBox(idm) {
    if (formPos != idm) {
        if (idm != 0) {
            $('#mainReact').show();
        } else {
            $('#mainReact').hide();
        }
        var oldPos = document.getElementById('mess' + formPos);
        var newPos = document.getElementById('mess' + idm);
        formPos = idm;

        newPos.innerHTML = oldPos.innerHTML;
        newPos.style.display = 'block';
        oldPos.style.display = 'none';
        oldPos.innerHTML = '';
    }
}

function insAtCur(myField, myValue) {
    if (document.selection) {
        myField.focus();
        sel = document.selection.createRange();
        sel.text = myValue;
    } else if (myField.selectionStart || myField.selectionStart == '0') {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        myField.value =
            myField.value.substring(0, startPos) +
            myValue +
            myField.value.substring(endPos, myField.value.length);
    } else {
        myField.value += myValue;
    }
}

function checkChars() {
    var pocet = document.getElementById('frmCont').value.length;
    var cislo = 2000 - pocet;
    document.getElementById('remaining').innerHTML = cislo < 0 ? 0 : cislo;
    if (pocet > 1990) {
        document.getElementById('frmCont').value = document
            .getElementById('frmCont')
            .value.substring(0, 3600);
    }
}
var lastCont = 0;
function moveBadwords(iid, stat) {
    /* platí po hlavní (první) formulář na stránce */
    if (formPos == iid) {
        document.getElementById('mess0').innerHTML = document.getElementById(
            'mess' + iid,
        ).innerHTML;
        document.getElementById('mess0').style.display = 'block';
        formPos = 0;
    }

    if (lastCont == iid) {
        /* skrytí formuláře */
        document.getElementById('mess' + lastCont).style.display = 'none';
        lastCont = 0;
    } else {
        /* skrytí formuláře */
        if (lastCont != 0) {
            document.getElementById('mess' + lastCont).style.display = 'none';
        }

        /* zobrazení formuláře */
        if (stat == 1) {
            /* nahlášení příspěvku */
            document.getElementById('mess' + iid).innerHTML =
                document.getElementById('notifyCont').innerHTML;
            document.getElementById('mess' + iid).style.display = 'block';
            document.getElementById('mess' + iid).querySelector("input[name='id_message']").value =
                iid;
        } else if (stat == 0) {
            /* slovník */
            document.getElementById('mess' + iid).innerHTML =
                document.getElementById('badwords-cont').innerHTML;
            document.getElementById('mess' + iid).style.display = 'block';
        }

        lastCont = iid;
    }
}

function threadStatus(url, obj) {
    //alert(url + '?status=' + obj.value);
    window.location = url + '?status=' + obj.value;
}

(function ($) {
    $.fn.styledSelect = function () {
        return this.each(function () {
            // Cache the number of options
            var $this = $(this),
                numberOfOptions = $(this).children('option').length;

            // Hides the select element
            $this.addClass('s-hidden');

            // Wrap the select element in a div
            $this.wrap('<div class="styledSelect"></div>');

            // Insert a styled div to sit over the top of the hidden select element
            $this.after('<div class="select"></div>');

            // Cache the styled div
            var $styledSelect = $this.next('div.select');

            // Show the first select option in the styled div
            $styledSelect.text($this.children('option:selected').text());

            // Insert an unordered list after the styled div and also cache the list
            var $list = $('<ul />', {
                class: 'options',
            }).insertAfter($styledSelect);

            // Insert a list item into the unordered list for each select option
            for (var i = 0; i < numberOfOptions; i++) {
                $('<li />', {
                    text: $this.children('option').eq(i).text(),
                    rel: $this.children('option').eq(i).val(),
                }).appendTo($list);
            }

            // Cache the list items
            var $listItems = $list.children('li');

            // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
            $styledSelect.click(function (e) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $('div.select.active').each(function () {
                        $(this).removeClass('active').next('ul.options').hide();
                    });
                }
                $(this).toggleClass('active').next('ul.options').toggle();
            });

            // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
            // Updates the select element to have the value of the equivalent option
            $listItems.click(function (e) {
                e.stopPropagation();
                $styledSelect.text($(this).text()).removeClass('active');
                $this.val($(this).attr('rel'));
                $list.hide();
                /* alert($this.val()); Uncomment this for demonstration! */
            });

            // Hides the unordered list when clicking outside of it
            $(document).click(function () {
                $styledSelect.removeClass('active');
                $list.hide();
            });
        });
    };
})(jQuery);

/* pomocné funkce
--------------------------------------------------------------------------------*/
$.urlParam = function (url, name) {
    var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(url);
    return results !== null ? results[1] : 0;
};
/*function urlParam(url,name){ var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url); return (results !== null) ? results[1] : 0; } */

function fitFontToBox(where, fontSize, maxHeight) {
    if ($(where).height() > maxHeight) {
        fontSize = fontSize - 1;
        $(where)
            .css('font-size', fontSize + 'px')
            .css('line-height', fontSize + 'px');
        if ($(where).height() > maxHeight) {
            fitFontToBox(where, fontSize, maxHeight);
        }
    }
}

function fitFontToBreakingNews(where, fontSize, maxHeight, minLine) {
    if ($(where).height() > maxHeight) {
        var LineSize = '';
        fontSize = fontSize - 1;
        /*		alert('font size = ' + fontSize); */
        if (fontSize < minLine) {
            LineSize = minLine;
        } else {
            LineSize = fontSize;
        }

        $(where)
            .css('font-size', fontSize + 'px')
            .css('line-height', LineSize + 'px');
        if ($(where).height() > maxHeight) {
            fitFontToBreakingNews(where, fontSize, maxHeight, minLine);
        } else {
            // zarovnej horizontálně na střed prvku
            var horniPosun = (maxHeight - $(where).height()) / 2;
            $(where).css('margin-top', horniPosun + 'px');
        }
    }
}

/* náhodný výběr několika položek z pole */
function getRandomSubarray(arr, size) {
    var shuffled = arr.slice(0),
        i = arr.length,
        temp,
        index;
    while (i--) {
        index = Math.floor(i * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
    }
    return shuffled.slice(0, size);
}

/*!
 * hoverIntent r7 // 2013.03.11 // jQuery 1.9.1+
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 *
 * You may use hoverIntent under the terms of the MIT license.
 * Copyright 2007, 2013 Brian Cherne
 */
(function (e) {
    e.fn.hoverIntent = function (t, n, r) {
        var i = { interval: 100, sensitivity: 7, timeout: 0 };
        if (typeof t === 'object') {
            i = e.extend(i, t);
        } else if (e.isFunction(n)) {
            i = e.extend(i, { over: t, out: n, selector: r });
        } else {
            i = e.extend(i, { over: t, out: t, selector: n });
        }
        var s, o, u, a;
        var f = function (e) {
            s = e.pageX;
            o = e.pageY;
        };
        var l = function (t, n) {
            n.hoverIntent_t = clearTimeout(n.hoverIntent_t);
            if (Math.abs(u - s) + Math.abs(a - o) < i.sensitivity) {
                e(n).off('mousemove.hoverIntent', f);
                n.hoverIntent_s = 1;
                return i.over.apply(n, [t]);
            } else {
                u = s;
                a = o;
                n.hoverIntent_t = setTimeout(function () {
                    l(t, n);
                }, i.interval);
            }
        };
        var c = function (e, t) {
            t.hoverIntent_t = clearTimeout(t.hoverIntent_t);
            t.hoverIntent_s = 0;
            return i.out.apply(t, [e]);
        };
        var h = function (t) {
            var n = jQuery.extend({}, t);
            var r = this;
            if (r.hoverIntent_t) {
                r.hoverIntent_t = clearTimeout(r.hoverIntent_t);
            }
            if (t.type == 'mouseenter') {
                u = n.pageX;
                a = n.pageY;
                e(r).on('mousemove.hoverIntent', f);
                if (r.hoverIntent_s != 1) {
                    r.hoverIntent_t = setTimeout(function () {
                        l(n, r);
                    }, i.interval);
                }
            } else {
                e(r).off('mousemove.hoverIntent', f);
                if (r.hoverIntent_s == 1) {
                    r.hoverIntent_t = setTimeout(function () {
                        c(n, r);
                    }, i.timeout);
                }
            }
        };
        return this.on({ 'mouseenter.hoverIntent': h, 'mouseleave.hoverIntent': h }, i.selector);
    };
})(jQuery);

/* definice všech globálních akcí po načtení stránky
--------------------------------------------------------------------------------*/

$(document).ready(function () {
    //	$('.stickyContent').stickyfloat({ duration: 400 });

    // hromadné zablokování klikání na prázdné odkazy
    $("a[href='#']").click(function (e) {
        e.preventDefault();
    });

    /*** tabs */
    $('.tabsNavigation a').click(function (e) {
        e.preventDefault();
        var tab = $(this).attr('href');
        $(this).closest('.tabsArea').find('.tabsPanel').addClass('displayNone');
        $(this).closest('.tabsArea').find('.tabsNavigation a').removeClass('active');
        $(this).addClass('active');
        $(tab).removeClass('displayNone');
    });

    // prepinac fontu
    // $('body').append('<div class="fontSwitch" style="position: absolute;top: 10px;left: 10px;background: red;padding: 10px;color: white;"><span class="ExtraBold" style="padding: 10px;font-weight:bold;">ExtraBold</span>|<span class="Bold" style="padding: 10px;">Bold</span></div>');
    // $('.fontSwitch .ExtraBold').click(function() {
    // 	$('.fontSwitch span').removeAttr('style').css('padding','10px');
    // 	$(this).css('font-weight','bold');
    // 	$('head .fontCSS').remove();
    // });
    // $('.fontSwitch .Bold').click(function() {
    // 	$('.fontSwitch span').removeAttr('style').css('padding','10px');
    // 	$(this).css('font-weight','bold');
    // 	$('head').append('<link class="fontCSS" rel="stylesheet" type="text/css" href="http://blesk.antos.webdev/css/blesk/dist/blesk-condensed-bold.css?v=6">')
    // });
});

/*cookie--------------------------------------------------*/
var datum = new Date().getTime();
$.cookie('visited', datum, { expires: 90, path: '/' });

var datumNow = new Date().getTime();
var datumNewUser = new Date().getTime();
if ($.cookie('newuser') == null) {
    $.cookie('newuser', '1', { expires: 60, path: '/' });
}
if ($.cookie('newuserDatum') == null) {
    $.cookie('newuserDatum', datumNewUser, { expires: 60, path: '/' });
}

if ($.cookie('visited') == null) {
    //cookie není nastavena
    newUser = 1;
    $.cookie('newuser', '1', { expires: 60, path: '/' });
} else if (
    datumNow - $.cookie('newuserDatum') < 1000 * 60 * 60 * 24 &&
    $.cookie('newuser') == '1'
) {
    // cookie je mladší než den
    newUser = 1;
    $.cookie('newuser', '1', { expires: 60, path: '/' });
} else if (datumNow - $.cookie('visited') > 1000 * 60 * 60 * 24 * 60) {
    // cookie je starší 60 dní
    newUser = 1;
    $.cookie('newuser', '1', { expires: 60, path: '/' });
} else {
    newUser = 0;
    $.cookie('newuser', '0', { expires: 60, path: '/' });
}

/* redirect to hp in articles when scrolling at the end of page */
$(document).ready(function () {
    if ($('#redirecter').length) {
        var prevScroll = 0;
        var width = 0;
        var prevWidth = 0;
        var opacity = 0.3;
        var redirect_active = false;
        var timer;

        $('#redirecter').css('width', '188px');
        /* $('#hpPart1').load("http://blesk.hovorka.dev #body-wrapper  .headerMenu");
	    $('#hpPart2').load("http://www.blesk.cz #body-wrapper .promoBox2015",
	    	function(){
	    		$('.promoboxPosition-0 .title').css("display","block");
	    	});

	    */

        window.onscroll = function () {
            if (timer) clearTimeout(timer);

            timer = setTimeout(function () {
                if (
                    (window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 600 ||
                        width > 0) &&
                    redirect_active != true
                ) {
                    if (window.pageYOffset > prevScroll && width < 940) {
                        width = width + 188;

                        $('#redirecter').animate({ width: width }, 200);
                        $('#hpPart1,#hpPart2').animate({ opacity: opacity }, 200);
                        opacity = opacity + 0.08;

                        if (
                            width >= 940 ||
                            window.innerHeight + window.pageYOffset >= document.body.offsetHeight
                        ) {
                            width = 940;
                            opacity = 0.9;
                            $('#redirecter').animate({ width: 940 }, 200);
                            $('#hpPart1,#hpPart2').animate({ opacity: opacity }, 300);
                            if (prevWidth > 600) {
                                setTimeout(function () {
                                    window.location.href = 'http://www.blesk.cz/?redir=1';
                                }, 200);
                            }
                            $('.hpWrapper').css('height', '601px');
                        }
                    } else {
                        if (width == 940 && window.pageYOffset >= prevScroll) {
                            redirect_active = true;
                            window.location.href = 'http://www.blesk.cz/?redir=1';
                        } else {
                            width = window.pageYOffset + 300 < prevScroll ? 0 : width - 188;
                            opacity = opacity > 0.4 ? opacity - 0.08 : 0.3;
                            $('.hpWrapper').css('height', '600px');
                            $('#hpPart1,#hpPart2').animate({ opacity: opacity }, 200);
                            $('#redirecter').animate({ width: width }, 200);
                        }
                    }
                }

                if (width <= 0) {
                    width = 0;
                }
                prevWidth = width;
                prevScroll = window.pageYOffset;
            }, 70);
        };
    }
});

function fb_share_count(token, url, element) {
    $.ajax({
        url: 'https://graph.facebook.com/',
        dataType: 'jsonp',
        type: 'GET',
        data: { access_token: token, id: url },
        success: function (data) {
            console.log(data);
            $('.' + element).html(data.share.share_count);
        },

        error: function (data) {
            console.log(data);

            // send the error notifications to console
        },
    });
}
